import {Component, Inject, OnInit} from '@angular/core';
import {
  MAT_DIALOG_DATA, MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef
} from '@angular/material/dialog';
import {AisCommonModule, ErrorDialogComponent} from 'ais-common';
import {MatButton} from '@angular/material/button';
import {TranslateModule} from '@ngx-translate/core';
import {Znamka} from '../model/znamka';
import {HttpClient} from '@angular/common/http';
import {MatFormField} from '@angular/material/form-field';
import {MatOptgroup, MatOption, MatSelect} from '@angular/material/select';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {AppService} from '../app.service';

class Predmet {
  id: number;
  idPredmet: number;
  kodCastStPlanu: string;
  kodTypVyucby: string;
  nazov: string;
  akRok: string;
}

class Predmety {
  akRok: string;
  predmety: Predmet[];
}

@Component({
    selector: 'app-opakovany-zapis',
    imports: [
        AisCommonModule,
        MatFormFieldModule,
        MatButton,
        MatDialogActions,
        MatDialogClose,
        MatDialogContent,
        TranslateModule,
        MatFormField,
        MatSelect,
        ReactiveFormsModule,
        MatOption,
        MatOptgroup,
        FormsModule
    ],
    templateUrl: './opakovany-zapis.component.html',
    styleUrl: './opakovany-zapis.component.css'
})
export class OpakovanyZapisComponent implements OnInit {
  protected predmet: Znamka;
  protected predmety: Predmety[];
  private aisRest = '/ais/rest/portal';
  selectedId = 0;

  constructor(
    public dialogRef: MatDialogRef<OpakovanyZapisComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      predmet: Znamka
    },
    private http: HttpClient,
    public dialog: MatDialog,
    private appService: AppService
  ) {
    this.predmet = data.predmet;
  }

  ngOnInit(): void {
    this.http.get<Predmet[]>(this.aisRest + '/student/opakovany-zapis/predmety/' + this.predmet.idStudium + '/' + this.predmet.kodCastSP)
      .subscribe({
        next: (data) => {
          this.predmety = this.parseData(data);
        },
        error: (error) => {
          console.error(error);
        }
      });
  }

  save()
  {
    const url = this.aisRest + '/student/opakovany-zapis/' + this.predmet.id + '/' + this.selectedId;

    this.http.post<string>(url, [])
      .subscribe({
        next: () => {
          this.appService.refreshPredmety();
          this.dialogRef.close();
        },
        error: (error) => {
          this.dialog.open(ErrorDialogComponent, {
            data: {
              message: error.error.message
            }
          });
        }
      });
  }

  private parseData(data: Predmet[]): Predmety[] {
    const predmety = new Map<string, Predmety>();

    data.forEach(p => {
      if (p.idPredmet !== this.predmet.idPredmet) {
        if (!predmety.has(p.akRok)) {
          predmety.set(p.akRok, {
            akRok: p.akRok,
            predmety: []
          });
        }

        const group = predmety.get(p.akRok);
        group.predmety.push(p);
      }
    });

    return Array.from(predmety.values());
  }
}
